import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { CART } from "../constants/query.constants";
import { addtoCart, decreaseCartQuantity, getUserCarts, increaseCartQuantity, removeCartItem, updateCart } from "../repositories/cart/cartRepository";
import toast from "react-hot-toast";

export const useGetCart = () => {
  return useQuery({
    queryKey: [CART],
    queryFn: getUserCarts,
  });
};

export const useAddToCart = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => addtoCart(payload),
    onMutate: async (payload) => {
      await queryClient.cancelQueries([CART]);

      const previousCart = queryClient.getQueryData([CART]);
      queryClient.setQueryData([CART], (old) => {
        if (!old) return [];

        return [
          ...old,
          {
            product_id: payload.product_id,
            quantity: payload.quantity,
            __optimistic: true,
          },
        ];
      });

      return { previousCart };
    },

    onError: (error, variables, context) => {
      queryClient.setQueryData([CART], context.previousCart);
      toast.error("Failed to add to cart");
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CART]);
    },
  });
};

export const useRemoveCartItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => removeCartItem(id),
    onSuccess: () => {
      queryClient.invalidateQueries([CART]);
    },
    onError: (err) => {
      toast.error(err?.message || "Oops failed to remove cart item..");
    },
  });
};





export const useIncreaseCartQty = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: increaseCartQuantity,
    onMutate: async (payload) => {
      await queryClient.cancelQueries([CART]);
      const previousCart = queryClient.getQueryData([CART]);
      queryClient.setQueryData([CART], (old) =>
        old?.map((item) =>
          item.product_id === payload.product_id
            ? {
                ...item,
                quantity: item.quantity + 1,
                total_price: (
                  Number(item.price) * (item.quantity + 1)
                ).toFixed(2),
              }
            : item
        )
      );

      return { previousCart };
    },

    onError: (_, __, context) => {
      queryClient.setQueryData([CART], context.previousCart);
      toast.error("Failed to increase quantity");
    },

    onSuccess: () => {
      queryClient.invalidateQueries([CART]);
    },
  });
};


export const useDecreaseCartQty = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: decreaseCartQuantity,
    onMutate: async (payload) => {
      await queryClient.cancelQueries([CART]);
      const previousCart = queryClient.getQueryData([CART]);
      queryClient.setQueryData([CART], (old) =>
        old?.map((item) =>
          item.product_id === payload.product_id
            ? {
                ...item,
                quantity: item.quantity - 1,
                total_price: (
                  Number(item.price) * (item.quantity - 1)
                ).toFixed(2),
              }
            : item
        )
      );

      return { previousCart };
    },

    onError: (_, __, context) => {
      queryClient.setQueryData([CART], context.previousCart);
      toast.error("Failed to decrease quantity");
    },

    onSuccess: () => {
      queryClient.invalidateQueries([CART]);
    },
  });
};


